import index from './index';
import integration from './integration';
import marketplace from './marketplace';
import { Router } from '@/legacy/Router';

Router.get('integration', index);
Router.get('integration/:any', integration);
Router.get('marketplace', marketplace);
